/* eslint-disable react/prop-types */
import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, MenuItem, TextField } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Badge from '@mui/material/Badge'
import { userSorting } from "../../config/sortingLabels";
import useTranslation from '../../hooks/useTranslation'
import { ListTableActions } from '../../shared-components'

const styles = {
  badge: { padding: '0 4px' },
  grid: { width: '100%' },
  tabs: { backgroundColor: '#F5F5F5' }
}

const tabCounter = (count) => {
  return <Badge sx={styles.badge} badgeContent={count} color="primary" />
}

const CustomTabPanel = ({ tableActionsState, currentTab, tabLabels, tabContents, handleTabChange, tabCounts, paginationComponent, handleTableFiltering, roleFilterOptions }) => {
  const [searchTerm, setSearchTerm] = useState(tableActionsState.searchTerm)
  const [sortOptionSelected, setSortOptionSelected] = useState(tableActionsState.sorting)
  const [roleSelected, setRoleSelected] = useState(tableActionsState.role || '')
  const sortOptions = userSorting
  const { t } = useTranslation()

  useEffect(()=>{
    setSearchTerm(tableActionsState.searchTerm)
    setSortOptionSelected(tableActionsState.sorting)
    setRoleSelected(tableActionsState.role || '')
  },[tableActionsState])

  const handleFiltering = (type, value) => {
    let searchValue = type === 'search' ? value : searchTerm
    let sortValue = type === 'sort' ? value : sortOptionSelected
    let roleValue = type === 'role' ? value : roleSelected
    handleTableFiltering(type, value, { q: searchValue, sort_by: sortValue, tab: currentTab, role: roleValue })
  }

  const tableActions = (
    <ListTableActions
      searchText={t('labels.search_users')}
      searchTerm={searchTerm}
      sortOptionSelected={sortOptionSelected}
      getData={handleFiltering}
      sortOptions={sortOptions}
      translateText={t}
    />
  )

  return (
    <Grid container sx={styles.width}>
      <Grid container alignItems={'center'} spacing={1}>
        <Grid item xs={roleFilterOptions ? 5 : 7}>
          {tableActions}
        </Grid>
        {roleFilterOptions && (
          <Grid item xs={2}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label={t('labels.filter_users')}
              value={roleSelected}
              onChange={(e) => { setRoleSelected(e.target.value); handleFiltering('role', e.target.value) }}
            >
              {roleFilterOptions.map(({ label, value }) => (
                <MenuItem key={value} value={value}>{label}</MenuItem>
              ))}
            </TextField>
          </Grid>
        )}
        <Grid item xs={5}>
          {paginationComponent}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          component={Paper}
          variant='fullWidth'
          sx={styles.tabs} >
          {tabLabels && Object.keys(tabLabels).map(key => (<Tab icon={tabCounts && tabCounter(tabCounts[key])} iconPosition="end" key={key} label={tabLabels[key]} value={key} />))}
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        {tabContents && tabContents[currentTab]}
      </Grid>
      <Grid container item xs={12} justifyContent='flex-end'>
        {paginationComponent}
      </Grid>
    </Grid>
  )
}

CustomTabPanel.propTypes = {
  tabContents: PropTypes.object.isRequired,
  tabLabels: PropTypes.object.isRequired,
  currentTab: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  tabCounts: PropTypes.object,
  paginationComponent: PropTypes.element
}

export default CustomTabPanel
